import script from "./Ip.vue?vue&type=script&setup=true&lang=js"
export * from "./Ip.vue?vue&type=script&setup=true&lang=js"

import "./Ip.vue?vue&type=style&index=0&id=cab3dfec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cab3dfec"]])

export default __exports__